import React from 'react'
import { SlIcon } from '@shoelace-style/shoelace/dist/react'
import StyledNetworkItem from '../styles'

const CoinMarketCap: React.FC = () => (
  <StyledNetworkItem
    className="text-brand-cmc"
    href="https://coinmarketcap.com/exchanges/nomiswap"
    target="_blank"
    rel="noreferrer noopener"
  >
    <SlIcon library="social" name="coinmarketcap" />
  </StyledNetworkItem>
)
export default CoinMarketCap
